import React from 'react';
import BatterTableColumnSet from '../../utils/column/batterTableColumnSet';
import _ from 'lodash';
import {Tooltip} from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import { useTranslation } from 'react-i18next';

function BatterTable({data, column}) {
    let columnSet = BatterTableColumnSet(column);
    const { t } = useTranslation();

    return (
    <>
    <table>
        <thead>
            <tr>
            {
            columnSet.map((item, idx) => (
                <th key={item['key']}
                style={{whiteSpace: 'pre-wrap', textAlign:'center'}}
                id={column+"/"+item['property']}
                >
                    <Tooltip anchorId={column+"/"+item['property']}
                    content={item['tooltip'] ? item['tooltip'] : item['column']}
                    place="top"
                    clickable={true}/>
                    {item['column']}
                </th>
            ))
            }
            </tr>
        </thead>
        <tbody>
            {
            (data && data.length != 0) ? 
            data.map((playerData) => (
                <tr key={playerData['type']}>
                { 
                columnSet.map((item) => (
                    item['cellRender'] ?
                    item['cellRender'](item['key'], item['property'], playerData) :
                    <td key={item['key']+"_"+item['property']}>{t(playerData[item['property']])}</td>
                ))
                }
                </tr>
            ))
            :
            <tr>
                <td colSpan={columnSet.length}>
                    No Data
                </td>
            </tr>
            }
        </tbody>
    </table>
    </>
    )
}

export default BatterTable;